export const sidebarMenuConfig = [
    {
        id: "",
        menuTitle: "Clients",
        collapsedMenuTitle: "",
        navigationPath: '/clients',
        menuIcon: "fluent-mdl2:workforce-management",
        menuKey: 1,
        children: [],
    },
    {
        id: "templates",
        menuTitle: "Templates",
        collapsedMenuTitle: "",
        navigationPath: '#',
        menuIcon: "grommet-icons:document-config",
        menuKey: 2,
        children: [
            {
                // groupLabel: "Templates",
                items: [
                    {
                        id: "report_templates",
                        subMenuName: "Report Templates",
                        navigationPath: "/reportTemplates",
                        menuIcon: "fluent-mdl2:report-warning",
                        menuKey: 1,
                    },
                    {
                        id: "word_documents",
                        subMenuName: "Word Documents",
                        navigationPath: "/wordDocuments",
                        menuIcon: "ix:doc-document",
                        // menuIcon: "ant-design:file-word-twotone",
                        menuKey: 2,
                    },
                    {
                        id: "xsd_templates",
                        subMenuName: "XSD Templates",
                        navigationPath: "/xsdTemplates",
                        menuIcon: "ix:xls-document",
                        menuKey: 3,
                    },
                    {
                        id: "xml_reports",
                        subMenuName: "XML Reports",
                        navigationPath: "/xmlReports",
                        menuIcon: "ix:xml-document",
                        menuKey: 4,
                    },
                ],
            },
        ],
    },
    {
        id: "administrator",
        menuTitle: "Administrator",
        collapsedMenuTitle: "",
        navigationPath: '#',
        menuIcon: "clarity:administrator-line",
        menuKey: 3,
        children: [
            {
                // groupLabel: "Administrator",
                items: [
                    {
                        id: "user_management",
                        subMenuName: "User Management",
                        navigationPath: "/UserManagement",
                        menuIcon: "fluent:people-team-32-regular",
                        menuKey: 1,
                    },
                    {
                        id: "basis_types",
                        subMenuName: "Basis Types",
                        navigationPath: "/BasisTypes",
                        menuIcon: "fluent:group-list-24-filled",
                        menuKey: 2,
                    },
                    {
                        id: "liability_types",
                        subMenuName: "Liability Types",
                        navigationPath: "/liabilityTypes",
                        menuIcon: "hugeicons:add-to-list",
                        menuKey: 3,
                    },
                    {
                        id: "report_types",
                        subMenuName: "Report Types",
                        navigationPath: "/ReportTypes",
                        menuIcon: "fluent-mdl2:document-set",
                        menuKey: 4,
                    },
                    {
                        id: "master_field_categories",
                        subMenuName: "Master Field Categories",
                        navigationPath: "/MasterFieldCategories",
                        menuIcon: "carbon:category-new-each",
                        // menuIcon: "mdi:focus-field",
                        menuKey: 5,
                    },
                    {
                        id: "master_valuation_fields",
                        subMenuName: "Master Valuation Fields",
                        navigationPath: "/MasterValuationFields",
                        menuIcon: "tdesign:calculation-1",
                        menuKey: 6,
                    },
                ],
            },
        ],
    },
];